import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { splitFileName, formatFileSize } from '../utils/formatters';

const Container = styled.span`
  display: inline-flex;
  min-width: 0;
  align-items: baseline;
  max-width: 100%;
`;

const BaseName = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Extension = styled.span`
  white-space: nowrap;
  flex-shrink: 0;
`;

const Size = styled.span`
  white-space: nowrap;
  flex-shrink: 0;
  margin-left: 4px;
  opacity: 0.6;
`;

const ELLIPSIS = '…';

const TruncatedFileName = ({ filename, fileSize, maxLength, className, style, onClick }) => {
  const { baseName, extension } = splitFileName(filename);

  let displayBase = baseName;
  if (maxLength && (baseName.length + extension.length) > maxLength) {
    const room = Math.max(1, maxLength - extension.length - ELLIPSIS.length);
    displayBase = baseName.slice(0, room) + ELLIPSIS;
  }

  return (
    <Container className={className} style={style} title={filename} onClick={onClick}>
      <BaseName>{displayBase}</BaseName>
      {extension && <Extension>{extension}</Extension>}
      {fileSize && (
        <Size>({formatFileSize(fileSize)})</Size>
      )}
    </Container>
  );
};

TruncatedFileName.propTypes = {
  filename: PropTypes.string,
  fileSize: PropTypes.number,
  maxLength: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
};

export default TruncatedFileName;
